import ReactGA from 'react-ga4';

export const initializeGA = () => {
  ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);
};

export const trackPageView = (page) => {
  ReactGA.send({ hitType: 'pageview', page });
};

export const setUserID = (userID) => {
  ReactGA.set({ user_id: userID });
};

export const removeUserID = () => {
  ReactGA.set({ user_id: null });
};

export const sendEvent = ReactGA.event

export const setProperties = (user_properties) => ReactGA.set({user_properties});

